export class FetchStudentListAction {
  static readonly type = '[Student Page] Fetch Student List';
  constructor() {}
}
